import { Component, input } from '@angular/core';
import { SharedModule } from '@app/modules/shared.module';
import { DevPhysiquePhysiologique, FirstDA } from '@app/models/carnet-liaison';
import {
  getFirstDate,
  formatFirstDate,
  getItemsToShow,
} from '../../carnet-liaison.utils';
import {
  MOMENT_SIESTE_LABELS,
  BOIT_LABELS,
  MANGE_LABELS,
  AUTONOMIE_REPAS_LABELS,
  TEXTURE_LABELS,
  DIVERSIFICATION_STATUT_LABELS,
  PORT_COUCHE_LABELS,
  CHANGE_LABELS,
  BIBERON_LABELS,
  LAIT_LABELS,
  EAU_LABELS,
  TEMPERATURE_LABELS,
  TYPE_REPAS_LABELS,
  QUANTITE_REPAS_LABELS,
  LEGUME_FECULENT_06_LABELS,
  LEGUME_FECULENT_6PLUS_LABELS,
  HYGIENE_ENFANT_LABELS,
} from '../../carnet-liaison.constants';

@Component({
  selector: 'app-carnet-dev-physiologique',
  templateUrl: './carnet-dev-physiologique.component.html',
  styleUrl: './carnet-dev-physiologique.component.scss',
  standalone: true,
  imports: [SharedModule],
})
export class CarnetDevPhysiologiqueComponent {
  data = input<DevPhysiquePhysiologique | null>(null);
  firstDA = input<FirstDA | null>(null);
  selectedDate = input<Date | null>(null);

  readonly momentSiesteLabels = MOMENT_SIESTE_LABELS;
  readonly boitLabels = BOIT_LABELS;
  readonly mangeLabels = MANGE_LABELS;
  readonly autonomieRepasLabels = AUTONOMIE_REPAS_LABELS;
  readonly textureLabels = TEXTURE_LABELS;
  readonly diversificationStatutLabels = DIVERSIFICATION_STATUT_LABELS;
  readonly portCoucheLabels = PORT_COUCHE_LABELS;
  readonly changeLabels = CHANGE_LABELS;
  readonly biberonLabels = BIBERON_LABELS;
  readonly laitLabels = LAIT_LABELS;
  readonly eauLabels = EAU_LABELS;
  readonly temperatureLabels = TEMPERATURE_LABELS;
  readonly typeRepasLabels = TYPE_REPAS_LABELS;
  readonly quantiteRepasLabels = QUANTITE_REPAS_LABELS;
  readonly legumeFeculent06Labels = LEGUME_FECULENT_06_LABELS;
  readonly legumeFeculent6plusLabels = LEGUME_FECULENT_6PLUS_LABELS;
  readonly hygieneEnfantLabels = HYGIENE_ENFANT_LABELS;

  formatFirstDate = formatFirstDate;

  getFirstDate(fieldName: string, optionKey: string): string | null {
    return getFirstDate(this.firstDA(), 'DA_devPhysiquePhysiologique', fieldName, optionKey);
  }

  getVisibleItems(obj: Record<string, boolean> | null | undefined, labels: Record<string, string>, fieldName: string): { label: string; key: string }[] {
    return getItemsToShow(obj ?? {}, labels, this.firstDA(), 'DA_devPhysiquePhysiologique', fieldName, this.selectedDate());
  }
}
